import { range } from 'lodash';
import { initialState } from 'config/vehicleLengthTool';

export function getYears(minYear, maxYear) {
	const yearOptions = [...initialState.years];
	yearOptions.push(
		...range(parseInt(maxYear), parseInt(minYear) - 1, -1)
		.map((year) => ({ value: year, display: year.toString() }))
	);
	return yearOptions;
}

// makes: [{
//   makeId: "acura",
//   makeDisplay: "Acura",
//   makeIsCommon: "1",
//   makeCountry: "USA"
// }]
export function getMakes({ payload }) {
	const makeOptions = [...initialState.makes];
	if (payload.makes) {
		makeOptions.push(...payload.makes.map((m) => ({ value: m.makeId, display: m.makeDisplay })));
	}
	return makeOptions;
}

// models: [{
//   modelName: "ILX",
//   modelMakeId: "Acura"
// }]
export function getModels({ payload }) {
	const modelOptions = [...initialState.models];
	if (payload.models) {
		modelOptions.push(...payload.models.map((m) => ({ value: m.modelName, display: m.modelName })));
	}
	return modelOptions;
}

// trims: [{
//   modelId: "69703",
//   modelLength: {
//     feet: 0,
//     inches: 0
//   }
// }]
export function getModelInfo({ payload }) {
	if (payload.trims && payload.trims.length) {
		return payload.trims[0];
	}
	return null;
}

export function handleError(props, noResponseCheck) {
	if (!noResponseCheck) {
		return (response) => {
			if (response.error) {
				props.handleStateOnChange({ hasError: true });
			}
			return response;
		};
	}
	return () => {
		props.handleStateOnChange({ hasError: true });
	};
}
